import React from 'react';

export const CloseButton = ({ ariaLabel, background = 'none', fill = '#181818', onClick, onKeyDown, refObj }) => {
    return (
        <button
            aria-label={ariaLabel || 'Close'}
            className="clx-step__button-nav"
            onClick={onClick}
            onKeyDown={onKeyDown}
            ref={refObj}
            style={{ background: background }}
            tabIndex={0}
        >
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
                <line
                    stroke={fill}
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="2px"
                    x1="19"
                    y1="1"
                    x2="1"
                    y2="19"
                />
                <line
                    stroke={fill}
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="2px"
                    x1="1"
                    y1="1"
                    x2="19"
                    y2="19"
                />
            </svg>
        </button>
    );
};

export const ForwardButton = ({ ariaLabel, onClick, onKeyDown, refObj }) => {
    return (
        <button
            aria-label={ariaLabel || 'Next Step'}
            className="clx-step__button-nav"
            onClick={onClick}
            onKeyDown={onKeyDown}
            ref={refObj}
            tabIndex={0}
        >
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="-6 0 24 24">
                <polyline
                    stroke="#181818"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="2px"
                    points="1 1 10 10 1 19"
                />
            </svg>
        </button>
    );
};

export const BackwardButton = ({ ariaLabel, onClick, onKeyDown, refObj, disabled }) => {
    const style = {
        visibility: disabled ? 'hidden' : 'visible'
    };

    return (
        <button
            aria-label={ariaLabel || 'Previous Step'}
            className="clx-step__button-nav"
            onClick={onClick}
            onKeyDown={onKeyDown}
            ref={refObj}
            tabIndex={0}
            disabled={disabled}
            style={style}
        >
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="-6 0 24 24">
                <polyline
                    stroke="#181818"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="2px"
                    points="10 1 1 10 10 19"
                />
            </svg>
        </button>
    );
};
